$(".slideshow-main").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  asNavFor: ".slideshow-nav",
  prevArrow:
    '<a href="#" class="slideshow-arrow previous" aria-label="Previous"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
  nextArrow:
    '<a href="#" class="slideshow-arrow next" aria-label="Next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
});
$(".slideshow-nav").slick({
  slidesToShow: 7,
  slidesToScroll: 1,
  asNavFor: ".slideshow-main",
  // dots: true,
  centerMode: true,
  focusOnSelect: true,
  arrows: false,
});
